

const setOpenRadio = ({commit}, bool) => commit('SHOW_OPEN_RADIO', bool)

const setOpenSelect = ({commit}, bool) => commit('SET_OPEN_SELECT', bool)

const setStartDate = ({commit}, date) => commit('SET_START_DATE', date)

const setEndDate = ({commit}, date) => commit('SET_END_DATE', date)

const setMonth = ({commit}, month) => commit('SET_MONTH', month)

const setDateNMonth =({commit, dispatch}, { month, startDate, endDate }) => {
    if (month) dispatch('setMonth', month)
    dispatch('setStartDate', startDate)
    dispatch('setEndDate', endDate)
}

const setSelectedYear = ({commit}, year) => commit('SET_SELECTED_YEAR', year)
const setSelectedMonth = ({commit}, month) => commit('SET_SELECTED_MONTH', month)

const setInit =({commit}) => commit('SET_INIT')



export default {
  setInit,
  setOpenRadio,
  setOpenSelect,
  setStartDate,
  setEndDate,
  setMonth,
  setDateNMonth,
  setSelectedYear,
  setSelectedMonth
}
